module.exports = __webpack_public_path__ + "img/mf-dash-header.42a7bcf7.jpg";